




























































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import { mapGetters } from 'vuex';

@Component({
    computed: {
        ...mapGetters({
            allLanguages: 'Localization/getAllLanguages',
        }),
    },
})
export default class ImportLanguageCsvForm extends Mixins(InputFieldMethods, NotifyMethods) {
    public attchedFile: any = null;
    public importLanguage: string = 'en';

    constructor() {
        super();
    }

    public addNewImportCsv(event: any) {
        const element = (event.target as HTMLInputElement);

        if (element.files.length === 0) {
            return;
        }
        this.attchedFile = (element.files[0] as File);

        element.type = 'text';
        element.type = 'file';
    }

    public importCsv() {
        if (!this.attchedFile) {
            return this.notify('attach_csv_first', 'warning');
        }

        this.$store.dispatch(Actions.IMPORT_LANGUAGE_CSV, { attchedFile: this.attchedFile, lang: this.importLanguage });
    }

    public cancel() {
        this.$store.commit(Mutations.SET_IMPORT_LANGUAGE_CSV_VISIBILITY, false);
    }
}
